





















import { Component, Vue } from "vue-property-decorator";
import registryService from "@/services/registry.service";
import { BSpinner } from "bootstrap-vue";

@Component({
  components: {
    BSpinner
  }
})
export default class SerialCounterDisplay extends Vue {
  private serialCounters: Record<string, number> = {};
  private loading = true;

  // Models to exclude from display
  private excludedModels = ["VK", "VPX", "VL"];

  private get displayCounters(): Record<string, number> {
    const counters: Record<string, number> = {};

    for (const [model, counter] of Object.entries(this.serialCounters)) {
      if (this.excludedModels.includes(model)) continue;

      // V1 in DB is actually VT (Trident) - serials are issued as VT.xxxx
      if (model === "V1") {
        counters["VT"] = counter;
      } else {
        counters[model] = counter;
      }
    }

    // Sort by counter descending (most popular first)
    return Object.fromEntries(
      Object.entries(counters).sort(([, a], [, b]) => b - a)
    );
  }

  private formatSerial(model: string, counter: number): string {
    // Next serial to be issued is counter + 1
    return `${model}.${counter + 1}`;
  }

  private async loadSerialCounters() {
    this.loading = true;
    try {
      this.serialCounters = await registryService.getSerialCounters();
    } catch (e) {
      console.error("Failed to load serial counters:", e);
    }
    this.loading = false;
  }

  created() {
    this.loadSerialCounters();
  }
}
